import React from 'react'
import { Redirect } from 'react-router-dom'

const OverviewPage = React.lazy(() => import('./pages/OverviewPage'))
const ItemsPage = React.lazy(() => import('./pages/ItemsPage'))
const ProductRecipesPage = React.lazy(() => import('./pages/ProductRecipesPage'))
const DocumentsPage = React.lazy(() => import('./pages/DocumentsPage'))
const BalancesPage = React.lazy(() => import('./pages/BalancesPage'))
const InventoryPage = React.lazy(() => import('./pages/InventoryPage'))
const AutomationPage = React.lazy(() => import('./pages/AutomationPage'))
const ReportsPage = React.lazy(() => import('./pages/ReportsPage'))
const SettingsPage = React.lazy(() => import('./pages/SettingsPage'))

const WarehouseRoutes = [
    { path: '/warehouse', exact: true, component: () => <Redirect to="/warehouse/overview" />, accessPageName: 'WAREHOUSE_VIEW' },
    { path: '/warehouse/overview', component: OverviewPage, accessPageName: 'WAREHOUSE_VIEW' },
    { path: '/warehouse/items', component: ItemsPage, accessPageName: 'WAREHOUSE_CATALOG_VIEW' },
    { path: '/warehouse/product-recipes', component: ProductRecipesPage, accessPageName: 'WAREHOUSE_CATALOG_VIEW' },
    { path: '/warehouse/documents', component: DocumentsPage, accessPageName: 'WAREHOUSE_DOCUMENT_VIEW' },
    { path: '/warehouse/balances', component: BalancesPage, accessPageName: 'WAREHOUSE_VIEW' },
    { path: '/warehouse/inventory', component: InventoryPage, accessPageName: 'WAREHOUSE_INVENTORY_VIEW' },
    { path: '/warehouse/automation', component: AutomationPage, accessPageName: 'WAREHOUSE_AUTOMATION_VIEW' },
    { path: '/warehouse/reports', component: ReportsPage, accessPageName: 'WAREHOUSE_REPORTS_VIEW' },
    { path: '/warehouse/settings', component: SettingsPage, accessPageName: 'WAREHOUSE_SETTINGS_VIEW' },
    { path: '/warehouse/Writing', component: DocumentsPage, accessPageName: 'WAREHOUSE_DOCUMENT_VIEW' },
    { path: '/warehouse/SelfWriting', component: AutomationPage, accessPageName: 'WAREHOUSE_AUTOMATION_VIEW' },
    { path: '/warehouse/Consignment', component: DocumentsPage, accessPageName: 'WAREHOUSE_DOCUMENT_VIEW' },
    { path: '/warehouse/Output', component: DocumentsPage, accessPageName: 'WAREHOUSE_DOCUMENT_VIEW' },
    { path: '/warehouse/Moving', component: DocumentsPage, accessPageName: 'WAREHOUSE_DOCUMENT_VIEW' },
    { path: '/warehouse/Stocktaking', component: InventoryPage, accessPageName: 'WAREHOUSE_INVENTORY_VIEW' },
]

export default WarehouseRoutes
